import { render, staticRenderFns } from "./VirtualPlayer.vue?vue&type=template&id=03fd8dd3&scoped=true&"
import script from "./VirtualPlayer.vue?vue&type=script&lang=ts&"
export * from "./VirtualPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualPlayer.vue?vue&type=style&index=0&id=03fd8dd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd8dd3",
  null
  
)

export default component.exports